import { getWindowObject } from '@eb/feature-detection';

/**
 * Safely check if the window exists and supports form data
 */
export const HAS_FORM_DATA = !!getWindowObject('FormData');
